import { BaseModel } from './../../../classes/base-model';

export class RoleGroup extends BaseModel {
    GroupId:number;
    RoleId:number;
}



// WEBPACK FOOTER //
// ./src/app/modules/role-module/models/role-group.ts